<template>
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      class="fill"
      d="M5.71429 7.16211C5.71429 6.98513 5.77449 6.81539 5.88165 6.69024C5.98882 6.56509 6.13416 6.49478 6.28571 6.49478H12C12.1516 6.49478 12.2969 6.56509 12.4041 6.69024C12.5112 6.81539 12.5714 6.98513 12.5714 7.16211C12.5714 7.3391 12.5112 7.50884 12.4041 7.63399C12.2969 7.75914 12.1516 7.82945 12 7.82945H6.28571C6.13416 7.82945 5.98882 7.75914 5.88165 7.63399C5.77449 7.50884 5.71429 7.3391 5.71429 7.16211ZM6.28571 10.4988H12C12.1516 10.4988 12.2969 10.4285 12.4041 10.3033C12.5112 10.1782 12.5714 10.0084 12.5714 9.83146C12.5714 9.65447 12.5112 9.48473 12.4041 9.35958C12.2969 9.23443 12.1516 9.16412 12 9.16412H6.28571C6.13416 9.16412 5.98882 9.23443 5.88165 9.35958C5.77449 9.48473 5.71429 9.65447 5.71429 9.83146C5.71429 10.0084 5.77449 10.1782 5.88165 10.3033C5.98882 10.4285 6.13416 10.4988 6.28571 10.4988ZM16 3.1581V13.1681C16 13.6991 15.8194 14.2083 15.4979 14.5838C15.1764 14.9592 14.7404 15.1701 14.2857 15.1701H1.71429C1.26099 15.1702 0.826138 14.9605 0.504872 14.587C0.183606 14.2136 0.00207762 13.7067 0 13.1773V5.16011C0 4.98312 0.0602039 4.81338 0.167368 4.68823C0.274531 4.56308 0.419876 4.49277 0.571429 4.49277C0.722981 4.49277 0.868326 4.56308 0.97549 4.68823C1.08265 4.81338 1.14286 4.98312 1.14286 5.16011V13.1681C1.14286 13.3451 1.20306 13.5149 1.31022 13.64C1.41739 13.7652 1.56273 13.8355 1.71429 13.8355C1.86584 13.8355 2.01118 13.7652 2.11835 13.64C2.22551 13.5149 2.28571 13.3451 2.28571 13.1681V3.1581C2.28571 2.80412 2.40612 2.46464 2.62045 2.21434C2.83478 1.96404 3.12547 1.82343 3.42857 1.82343H14.8571C15.1602 1.82343 15.4509 1.96404 15.6653 2.21434C15.8796 2.46464 16 2.80412 16 3.1581ZM14.8571 3.1581H3.42857V13.1681C3.42886 13.3955 3.39576 13.6212 3.33071 13.8355H14.2857C14.4373 13.8355 14.5826 13.7652 14.6898 13.64C14.7969 13.5149 14.8571 13.3451 14.8571 13.1681V3.1581Z"
      fill="none"
    />
  </svg>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "NewsIcon",
});
</script>

<style scoped lang="scss">
@use "./icon.scss";
</style>
